import { render } from "./DeclinedTransfers.vue?vue&type=template&id=237c99a4"
import script from "./DeclinedTransfers.vue?vue&type=script&lang=js"
export * from "./DeclinedTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__